import { render, staticRenderFns } from "./TutorialInit.vue?vue&type=template&id=7bace283&"
import script from "./TutorialInit.vue?vue&type=script&lang=js&"
export * from "./TutorialInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports